import {
  LBTDivider,
  LBTDividerSize,
  LBTLabel,
  LBTSpacer,
} from '@laborability/components';
import Box, { BoxProps } from '@mui/material/Box';
import List, { ListProps } from '@mui/material/List';
import ListItem, { ListItemProps } from '@mui/material/ListItem';
import React from 'react';
import styled from 'styled-components';

export type LBTListProps = ListProps & {
  datatestid?: string;
};

export type LBTListItemProps = ListItemProps & {
  datatestid?: string;
};

const StyledList = styled(List)<ListProps & {}>(({ ...props }) => ({}));

const StyledListItem = styled(ListItem)<ListItemProps & {}>(({ ...props }) => ({
  padding: '16px 4px',
  minHeight: '57px',
}));

const CustomBox = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));

const AssocaafISEE: React.FC<LBTListProps> = ({
  datatestid = '',
  ...props
}: LBTListProps) => {
  return (
    <>
      <LBTLabel variant="smallCapsBold" component="h5" textAlign="left">
        costi
      </LBTLabel>
      <LBTSpacer spacing={2} isFixed />
      <StyledList disablePadding {...props}>
        <LBTDivider
          size={LBTDividerSize.MEDIUM}
          orientation="horizontal"
          width="100%"
        />
        <StyledListItem disablePadding>
          <CustomBox>
            <LBTLabel textAlign="left" variant="listTitle">
              Prima DSU
            </LBTLabel>

            <LBTLabel
              textAlign="right"
              variant="buttonLarge"
              component="strong"
            >
              0€
            </LBTLabel>
          </CustomBox>
        </StyledListItem>
        <LBTDivider orientation="horizontal" width="100%" />
        <StyledListItem disablePadding>
          <CustomBox>
            <LBTLabel
              textAlign="left"
              variant="listTitle"
              sx={{ maxWidth: '80%' }}
            >
              Presentazioni successive con variazione dei componenti del nucleo
              familiare
            </LBTLabel>

            <LBTLabel
              textAlign="right"
              variant="buttonLarge"
              component="strong"
            >
              0€
            </LBTLabel>
          </CustomBox>
        </StyledListItem>
        <LBTDivider orientation="horizontal" width="100%" />
        <StyledListItem disablePadding>
          <CustomBox>
            <LBTLabel
              textAlign="left"
              variant="listTitle"
              sx={{ maxWidth: '80%' }}
            >
              Richieste ed elaborazioni successive, per lo stesso nucleo e anno
            </LBTLabel>
            <LBTLabel
              textAlign="right"
              variant="buttonLarge"
              component="strong"
            >
              20€
            </LBTLabel>
          </CustomBox>
        </StyledListItem>
      </StyledList>
    </>
  );
};

export default AssocaafISEE;
